<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <ul id="unitoverTab" class="nav nav-tabs" role="tablist">
          <!-- <li class="nav-item" role="presentation">
            <button id="first-unitover" class="nav-link" data-bs-toggle="tab" data-bs-target="#firstUnitover"
              type="button" role="tab" aria-controls="firstUnitover" aria-selected="true" @click="onClickTab('1')">
              {{ $t("content.amnunitoverres") }}
            </button>
          </li> -->

          <li class="nav-item" role="presentation">
            <button id="second-unitover" class="nav-link" data-bs-toggle="tab" data-bs-target="#secondUnitover"
              type="button" role="tab" aria-controls="secondUnitover" aria-selected="false" @click="onClickTab('2')">
              {{ $t("content.amnunitoverman") }}
            </button>
          </li>
        </ul>

        <div id="unitoverTabContent" class="tab-content">
          <div id="firstUnitover" class="tab-pane fade" role="tabpanel" aria-labelledby="first-unitover">
            <div class="card h-100 mt-2">
              <div class="card-header mb-0">
                <h5>{{ $t("content.amnunitoverres") }}</h5>
              </div>
              <div class="card-body pt-0">
                <div class="row">

                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.status") }}</label>
                    <select v-model="status_search" class="form-select">
                      <option value="">{{ $t('content.optall') }}</option>
                      <option v-for="(a, sta) in list_odstatus" :key="sta" :value="a.value">
                        {{ a.items }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0 png"></label>
                    <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                      @click="loadBreakingListApi">
                      <i class="material-icons material-symbols-outlined">search</i>
                      {{ btnSearch }}
                    </material-button>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.issuedate") }}</th>
                          <th class="text-center">{{ $t("content.amnallticket") }}</th>
                          <th class="text-center">{{ $t("content.amnallitem") }}</th>
                          <th class="text-center">{{ $t("content.amnweightvalall") }}</th>
                          <th class="text-center">{{ $t("content.amnpawnvalall") }}</th>
                          <th>{{ $t("content.amnlastmaker") }}</th>
                          <th>{{ $t("content.status") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in listbk" :key="index">
                          <td class="text-sm font-weight-normal">
                            {{ formatNumberString((currentPageB - 1) * perPageB + index + 1) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ format_datetime(row.createDate) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberString(row.numOfTicket) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberString(row.quantity) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberDecimalString(row.weight) }}
                          </td>
                          <td class="text-sm font-weight-normal text-center">
                            {{ formatNumberDecimalString(row.pawnValue) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ row.userName }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ filterStatus(row.status) }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button color="primary" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="bottom" title=".xls" @click="XlsxGen(row)">
                              <i class="material-icons material-symbols-outlined">download</i>
                            </material-button>
                          </td>
                        </tr>
                        <tr v-if="listbk.length === 0">
                          <td colspan="10" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="11" style="text-align: right">Total Rows : {{ totalRows_sB }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listbk.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPageB" :total-items="totalRowsB"
                          :items-per-page="perPageB" @click="onClickHandlerBk" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div id="secondUnitover" class="tab-pane fade" role="tabpanel" aria-labelledby="second-unitover">
            <!-- filter global -->
            <div class="card mt-1">
              <div class="card-header px-3 py-3" v-if="subval === '1'">
                <h5>{{ $t("content.search_j6") }}</h5>
              </div>
              <div class="card-header px-3 py-3" v-else-if="subval === '2'">
                <h5>{{ $t("content.search_brek") }}</h5>
              </div>
              <div class="card-body px-3 py-3">
                <div class="row no-gutters" v-if="subval === '1'">
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.year") }}</label>
                    <select v-model="year_search" class="form-select" style="min-width: 80px" @change="loadPriodApi">
                      <option value="" disabled selected>{{ $t('content.select') }}</option>
                      <option v-for="(a, sel2) in years" :key="sel2" :value="a">
                        {{ a }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.month") }}</label>
                    <select v-model="month_search" class="form-select" @change="loadPriodApi">
                      <option value="" disabled selected>{{ $t('content.select') }}</option>
                      <option v-for="(a, sel3) in list_months" :key="sel3" :value="a.value">
                        {{ a.items }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.amnunovname") }}</label>
                    <select v-model="period_searchj" class="form-select" :disabled="listperiod.length === 0">
                      <option value="" disabled selected>{{ $t('content.select') }}</option>
                      <option v-for="(a, sel3) in listperiod" :key="sel3" :value="a.uid"
                        :disabled="a.responseDate === null">
                        {{ a.period }}
                      </option>
                    </select>
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{
                      $t("content.amnassetgroup")
                    }}</label>
                    <select v-model="cat_searchj" class="form-select">
                      <option value="">{{ $t("content.optall") }}</option>
                      <option v-for="(index) in listcat_order" :key="index" :data-id="index" :value="index">
                        <span v-if="listprint.length > 0 && listcat_order.length > 0">
                          {{ filterCat(index) }}
                        </span>
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.names") }}</label>
                    <div class="input-group">
                      <input v-model="cusName_searchj" type="text" class="form-control" aria-describedby="searchName"
                        readonly />
                      <button class="btn btn-primary" type="button" @click="openDialogCus">
                        <i class="material-icons material-symbols-outlined">search</i>
                      </button>
                      <button id="searchNameCus" class="btn btn-primary" type="button" data-bs-toggle="modal"
                        data-bs-target="#searchNameModal" v-show="false">
                      </button>
                    </div>
                  </div>
                  <div class="col-lg-auto">
                    <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                    <material-input v-model="tk_searchj" id="ticketno" type="text" />
                  </div>

                  <div class="col-auto">
                    <label class="form-label ms-0 png"></label>
                    <material-button id="cardSearch" color="primary" class="mb-3" :disabled="period_searchj === ''"
                      @click="loadJ6ListApi">
                      <i class="material-icons material-symbols-outlined">search</i>
                      {{ $t("buttons.sear") }}
                    </material-button>
                  </div>
                  <div class="col-auto">
                    <label class="form-label ms-0 png"></label>
                    <material-button id="cancSearch" color="danger" class="float-lg-start float-sm-end mb-3"
                      @click="cancelBtnJ6">
                      <i class="material-icons material-symbols-outlined">close</i>
                      {{ $t("buttons.canc") }}
                    </material-button>
                  </div>
                </div>
                <div class="row no-gutters" v-else-if="subval === '2'">
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{
                      $t("content.amnassetgroup")
                    }}</label>
                    <select v-model="cat_searchod" class="form-select">
                      <option value="">{{ $t("content.optall") }}</option>
                      <option v-for="(index) in listcat_order" :key="index" :data-id="index" :value="index">
                        <span v-if="listprint.length > 0 && listcat_order.length > 0">
                          {{ filterCat(index) }}
                        </span>
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-3">
                    <label class="form-label ms-0">{{ $t("content.names") }}</label>
                    <div class="input-group">
                      <input v-model="cusName_searchod" type="text" class="form-control" aria-describedby="searchName"
                        readonly />
                      <button class="btn btn-primary" type="button" @click="openDialogCus">
                        <i class="material-icons material-symbols-outlined">search</i>
                      </button>
                      <button id="searchNameCus" class="btn btn-primary" type="button" data-bs-toggle="modal"
                        data-bs-target="#searchNameModal" v-show="false">
                      </button>
                    </div>
                  </div>

                  <div class="col-lg-auto">
                    <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                    <material-input v-model="tk_searchod" id="ticketno" type="text" />
                  </div>
                  <div class="col-lg-2">
                    <label class="form-label ms-0">{{ $t("content.item") }}</label>
                    <select v-model="postpone_od" class="form-select">
                      <option value="">{{ $t('content.optall') }}</option>
                      <option value="Postpone">{{ $t('content.amndeferitems') }}</option>
                    </select>
                  </div>
                  <div class="col-auto">
                    <label class="form-label ms-0 png"></label>
                    <material-button id="cardSearch" color="primary" class="mb-3" @click="loadOverdueListApi">
                      <i class="material-icons material-symbols-outlined">search</i>
                      {{ $t("buttons.sear") }}
                    </material-button>
                  </div>
                  <div class="col-auto">
                    <label class="form-label ms-0 png"></label>
                    <material-button id="cancSearch" color="danger" class="float-lg-start float-sm-end mb-3"
                      @click="cancelBtnOd">
                      <i class="material-icons material-symbols-outlined">close</i>
                      {{ $t("buttons.canc") }}
                    </material-button>
                  </div>
                </div>


              </div>
            </div>

            <div class="row">
              <!-- Table list choice -->
              <div class="col-12">
                <div class="card h-100 mt-2">
                  <div class="card-header mb-0">
                    <h5 class="mb-0">{{ $t("content.amnunitover") }}</h5>
                  </div>
                  <div class="card-body pt-0">
                    <div class="row">
                      <div class="col-12"></div>
                      <ul id="unitoverManTab" class="nav nav-tabs" role="tablist">
                        <li class="nav-item" role="presentation">
                          <button id="first-unitoverman" class="nav-link" data-bs-toggle="tab"
                            data-bs-target="#firstUnitoverMan" type="button" role="tab" aria-controls="firstUnitoverMan"
                            aria-selected="true" @click="onClickSubTab('1')">
                            {{ $t("content.amnjor6period") }} </button>
                        </li>

                        <li class="nav-item" role="presentation">
                          <button id="second-unitoverman" class="nav-link" data-bs-toggle="tab"
                            data-bs-target="#secondUnitoverMan" type="button" role="tab"
                            aria-controls="secondUnitoverMan" aria-selected="true" @click="onClickSubTab('2')">
                            {{ $t("content.amnunovdue") }}
                          </button>
                        </li>
                      </ul>

                      <div id="unitoverManTabContent" class="tab-content">
                        <div id="firstUnitoverMan" class="tab-pane fade" role="tabpanel"
                          aria-labelledby="first-unitoverman">
                          <div class="card-body px-0">
                            <div class="row mt-3">
                              <div class="table-responsive" style="height: 600px; overflow-y: auto">
                                <table class="table table-flush">
                                  <thead class="thead-light sticky-top">
                                    <tr>
                                      <th class="checkbox">
                                        <material-checkbox v-model="allj" :checked="allj" name="allSelectJ6"
                                          @change="setAllJ6" :disabled="listj6.length === 0" />
                                      </th>
                                      <th>#</th>
                                      <th>{{ $t("content.ticketno") }}</th>
                                      <th>{{ $t("content.names") }}</th>
                                      <th>{{ $t("content.relatcus") }}</th>
                                      <th>{{ $t("content.amnpawndate") }}</th>
                                      <th>{{ $t("content.amndeferdate") }}</th>
                                      <th>{{ $t("content.amnassetdetail") }}</th>
                                      <th>{{ $t("content.amnweightvalall") }}</th>
                                      <th>{{ $t("content.amnqtyunitall") }}</th>
                                      <th>{{ $t("content.amnpawnvalall") }}</th>
                                      <th>{{ $t("content.act") }}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(row, index) in listj6" :key="index">
                                      <td class="text-sm font-weight-normal">
                                        <material-checkbox v-model="row.chk" :checked="row.chk"
                                          @change="selectJ6(row)" :disabled="row.catName === null || row.catName === undefined || row.catName === ''" />
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        {{ formatNumberString(index + 1) }}
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        {{ row.refNumber }}
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        <span @click="searchCustomer(row)"
                                          style="color:blue;text-decoration:underline;cursor: pointer">
                                          {{ row.cusName }}
                                        </span>
                                        <material-button data-bs-toggle="modal" data-bs-target="#exampleModal"
                                          id="exampleModalShow" v-show="false">
                                        </material-button>
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        <span v-if="row.relatedName !== null" @click="searchRlCustomer(row)"
                                          style="color:green;text-decoration:underline;cursor: pointer">
                                          {{ row.relatedName }}
                                        </span>
                                        <span v-else>{{ row.relatedName }}</span>
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        {{ format_date(row.pawnDate) }}
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        {{ format_date(row.postponeDate) }}
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        {{ row.catName }}
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        {{ formatNumberDecimalString(row.weight) }}
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        {{ formatNumberString(row.quantity) }}
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        {{ formatNumberDecimalString(row.pawnValue) }}
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        <material-button color="primary" variant="outline" class="rounded-circle"
                                          :title="t('content.managedefer')" @click="showModal(row)">
                                          <i class="material-icons material-symbols-outlined">update</i>
                                        </material-button>
                                        <material-button color="warning" variant="outline" class="rounded-circle"
                                          v-show="false" data-bs-toggle="modal" data-bs-target="#updateModal"
                                          id="addpostpone">
                                        </material-button>
                                        <material-button color="info" variant="outline" class="rounded-circle"
                                          :title="t('buttons.seed')" @click="openDetail(row)">
                                          <i class="material-icons material-symbols-outlined">visibility</i>
                                        </material-button>
                                        <material-button color="info" variant="outline" class="rounded-circle"
                                          v-show="false" data-bs-toggle="modal" data-bs-target="#lookupModal2"
                                          id="detailModal">
                                        </material-button>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div class="card-footer mt-0 pt-3">
                              <div class="row no-gutters">
                                <div class="col-12 d-flex justify-content-end align-items-center px-0">
                                  <material-button color="primary" class="ms-3" :disabled="listj6.length === 0 || !canimportj6
                                    " @click="setList">
                                    {{ btnImport }}
                                    <i class="material-icons material-symbols-outlined">arrow_downward</i>
                                  </material-button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div id="secondUnitoverMan" class="tab-pane fade" role="tabpanel"
                          aria-labelledby="second-unitoverman">
                          <div class="card-body px-0">
                            <div class="row mt-3">
                              <div class="table-responsive" style="height: 600px; overflow-y: auto">
                                <table class="table table-flush">
                                  <thead class="thead-light sticky-top">
                                    <tr>
                                      <th class="checkbox">
                                        <material-checkbox v-model="allod" :checked="allod" name="allSelectOd"
                                          @change="setAllOd" :disabled="listod.length === 0" />
                                      </th>
                                      <th>#</th>
                                      <th>{{ $t("content.ticketno") }}</th>
                                      <th>{{ $t("content.names") }}</th>
                                      <th>{{ $t("content.relatcus") }}</th>
                                      <th>{{ $t("content.amnpawndate") }}</th>
                                      <th>{{ $t("content.amndeferdate") }}</th>
                                      <th>{{ $t("content.amnassetdetail") }}</th>
                                      <th>{{ $t("content.amnweightvalall") }}</th>
                                      <th>{{ $t("content.amnqtyunitall") }}</th>
                                      <th>{{ $t("content.amnpawnvalall") }}</th>
                                      <th>{{ $t("content.act") }}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(row, index) in listod" :key="index">
                                      <td class="text-sm font-weight-normal">
                                        <material-checkbox v-model="row.chk" :checked="row.chk" 
                                         :disabled ="row.catName === null || row.catName === undefined || row.catName === ''"
                                         @change="selectOd(row)" />
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        {{ formatNumberString(index + 1) }}
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        {{ row.refNumber }}
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        <span @click="searchCustomer(row)"
                                          style="color:blue;text-decoration:underline;cursor: pointer">
                                          {{ row.cusName }}
                                        </span>
                                        <material-button data-bs-toggle="modal" data-bs-target="#exampleModal"
                                          id="exampleModalShow" v-show="false">
                                        </material-button>
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        <span v-if="row.relatedName !== null" @click="searchRlCustomer(row)"
                                          style="color:green;text-decoration:underline;cursor: pointer">
                                          {{ row.relatedName }}
                                        </span>
                                        <span v-else>{{ row.relatedName }}</span>
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        {{ format_date(row.pawnDate) }}
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        {{ format_date(row.postponeDate) }}
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        {{ row.catName }}
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        {{ formatNumberDecimalString(row.weight) }}
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        {{ formatNumberString(row.quantity) }}
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        {{ formatNumberDecimalString(row.pawnValue) }}
                                      </td>
                                      <td class="text-sm font-weight-normal">
                                        <material-button color="info" variant="outline" class="rounded-circle"
                                          :title="t('buttons.seed')" @click="openDetail(row)">
                                          <i class="material-icons material-symbols-outlined">visibility</i>
                                        </material-button>
                                        <material-button color="info" variant="outline" class="rounded-circle"
                                          v-show="false" data-bs-toggle="modal" data-bs-target="#lookupModal2"
                                          id="detailModal">
                                        </material-button>
                                        <!-- <material-button color="warning" variant="outline" class="rounded-circle"
                                          :title="t('content.managedefer')" @click="showModal(row)">
                                          <i class="material-icons material-symbols-outlined">edit_note</i>
                                        </material-button>
                                        <material-button color="warning" variant="outline" class="rounded-circle"
                                          v-show="false" data-bs-toggle="modal" data-bs-target="#updateModal"
                                          id="addpostpone">
                                        </material-button> -->
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div class="card-footer mt-0 pt-3">
                              <div class="row no-gutters">
                                <div class="col-12 d-flex justify-content-end align-items-center px-0">
                                  <material-button color="primary" class="ms-3"
                                    :disabled="listod.length === 0 || !canimportod" @click="setList">
                                    {{ btnImport }}
                                    <i class="material-icons material-symbols-outlined">arrow_downward</i>
                                  </material-button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <pre></pre>
              <pre></pre>

              <!-- Table list selected -->
              <div class="col-12">
                <div class="card h-100 mt-2">
                  <div class="card-header mb-0">
                    <div class="row">
                      <div class="col d-flex align-items-center">
                        <h5 class="mb-0">{{ $t("content.listselected") }}</h5>
                      </div>
                      <div class="col-auto">
                        <material-button color="primary" class="ms-3"
                          :disabled="!cansave || (selectedj6 !== 0 && selectedj6 !== totalj6) || list_uid.length === 0"
                          @click="addBreaking">
                          <i class="material-icons material-symbols-outlined">save</i>
                          {{ save }}
                        </material-button>
                      </div>
                    </div>
                  </div>
                  <div class="card-body pt-0">
                    <div class="row">
                      <div class="col-12">
                        <div style="width: 100%; height: 48px"></div>
                      </div>

                      <div class="tab-content">
                        <div class="card-body px-0">
                          <div class="row">
                            <div class="table-responsive" style="height: 600px; overflow-y: auto">
                              <table class="table table-flush">
                                <thead class="thead-light sticky-top">
                                  <tr>
                                    <th class="checkbox">
                                      <material-checkbox v-model="allse" :checked="allse" name="allSelected"
                                        @change="setAllSe" :disabled="list_selected.length === 0" />
                                    </th>
                                    <th>#</th>
                                    <th>{{ $t("content.ticketno") }}</th>
                                    <th>{{ $t("content.names") }}</th>
                                    <th>{{ $t("content.relatcus") }}</th>
                                    <th>{{ $t("content.amnpawndate") }}</th>
                                    <th>{{ $t("content.amndeferdate") }}</th>
                                    <th>{{ $t("content.amnassetdetail") }}</th>
                                    <th>{{ $t("content.amnweightvalall") }}</th>
                                    <th>{{ $t("content.amnqtyunitall") }}</th>
                                    <th>{{ $t("content.amnpawnvalall") }}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(row, index) in list_selected" :key="index">
                                    <td class="text-sm font-weight-normal">
                                      <material-checkbox v-model="row.chk" :checked="row.chk" @change="selectSe(row)" />
                                    </td>
                                    <td class="text-sm font-weight-normal">
                                      {{ formatNumberString(index + 1) }}
                                    </td>
                                    <td class="text-sm font-weight-normal">
                                      {{ row.refNumber }}
                                    </td>
                                    <td class="text-sm font-weight-normal">
                                      {{ row.cusName }}
                                    </td>
                                    <td class="text-sm font-weight-normal">
                                      {{ row.relatedName }}
                                    </td>
                                    <td class="text-sm font-weight-normal">
                                      {{ format_date(row.pawnDate) }}
                                    </td>
                                    <td class="text-sm font-weight-normal">
                                      {{ format_date(row.postponeDate) }}
                                    </td>
                                    <td class="text-sm font-weight-normal">
                                      {{ row.catName }}
                                    </td>
                                    <td class="text-sm font-weight-normal">
                                      {{ formatNumberDecimalString(row.weight) }}
                                    </td>
                                    <td class="text-sm font-weight-normal">
                                      {{ formatNumberString(row.quantity) }}
                                    </td>
                                    <td class="text-sm font-weight-normal">
                                      {{ formatNumberDecimalString(row.pawnValue) }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div class="card-footer mt-0 pt-3">
                            <div class="row no-gutters">
                              <div class="col-12 d-flex align-items-center px-0">
                                <material-button color="danger" :disabled="list_selected.length === 0 || !canexport"
                                  @click="unsetList">
                                  <i class="material-icons material-symbols-outlined">close</i>
                                  {{ btnExport }}
                                </material-button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Search Customer Dialog -->
        <div id="searchNameModal" class="modal fade" tabindex="-1" aria-labelledby="searchNameModalLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t("content.cnamelist") }}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeModal">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>

              <div class="modal-body">
                <div class="preview-table">
                  <section class="panel">
                    <table class="table table-striped table-responsive">
                      <thead>
                        <tr>
                          <!-- <th style="width: 100px">{{ $t("content.ccode") }}</th> -->
                          <th>#</th>
                          <th>{{ $t("content.cnameth") }}</th>
                          <th>{{ $t("content.cnameen") }}</th>
                          <th>{{ $t("content.docno") }}</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="row-search">
                          <td></td>
                          <td>
                            <material-input v-model="nameThC" type="text" :label="t('content.cnameth')" />
                          </td>
                          <td>
                            <material-input v-model="nameEnC" type="text" :label="t('content.cnameen')" />
                          </td>
                          <td>
                            <material-input v-model="docNumberC" type="text" :label="t('content.docno')" />
                          </td>
                          <td>
                            <material-button color="primary" variant="contain" class="rounded-circle ms-1"
                              data-bs-toggle="tooltip" data-bs-placement="top" :title="btnSearch"
                              :disabled="nameThC.length < 2 && nameEnC.length < 2 && docNumberC.length < 5"
                              @click="loadCustomerAfListApi">
                              <i class="material-icons material-symbols-outlined">search</i>
                            </material-button>
                          </td>
                        </tr>
                        <tr v-for="(row, index) in customerlist" :key="index" @click="selectCus(row)">
                          <td>{{ formatNumberString((currentPageC - 1) * perPageC + index + 1) }}</td>
                          <td>{{ row.nameTh }}</td>
                          <td>{{ row.nameEn }}</td>
                          <td colspan="2">{{ row.docNumber }}</td>
                        </tr>
                        <tr v-if="customerlist.length === 0">
                          <td colspan="5" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </section>
                </div>
              </div>

              <div class="modal-footer">
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="customerlist.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPageC" :total-items="totalRowsC"
                          :items-per-page="perPageC" @click="onClickHandlerC" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Delete Dialog -->
        <div id="deleteModal" class="modal fade" tabindex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t("dlgs.hdDel") }}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>

              <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-default" data-bs-dismiss="modal">
                  {{ cancel }}
                </button>
                <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
                  {{ confirm }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Update Dialog -->
        <div id="updateModal" class="modal fade" tabindex="-1" aria-labelledby="updateModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t("content.update") }}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>

              <div class="modal-body">
                <fieldset>
                  <div class="row">
                    <div class="col-lg-4">
                      <div class="d-flex align-items-center mb-1">
                        <label class="form-label ms-0 mb-0 me-3">
                          {{ $t("content.oldduedate") }}
                        </label>
                      </div>
                      <VueDatePicker v-model="postpone_detail.oldduedate" :format="format" auto-apply :teleport="true"
                        :disabled="true" :enable-time-picker="false" month-name-format="long" :clearable="false"
                        :text-input="textInputOptions" fluid />

                    </div>

                    <div class="col-lg-4">
                      <div class="d-flex align-items-center mb-1">
                        <label class="form-label ms-0 mb-0 me-3">
                          {{ $t("content.newduedate") }}
                        </label>
                      </div>

                      <VueDatePicker v-model="postpone_detail.postponeDate" :format="format" auto-apply :teleport="true"
                        :enable-time-picker="false" month-name-format="long" :clearable="false" fluid
                        :text-input="textInputOptions" :min-date="new Date(postpone_detail.oldduedate)"
                        @update:model-value="diffDate" />
                    </div>

                    <div class="col-lg-4">
                      <div class="d-flex align-items-center mb-1">
                        <label class="form-label ms-0 mb-0 me-3">
                          {{ $t("content.amnduedateadd") }}
                        </label>
                      </div>
                      <material-input id="increaseday" v-model="postpone_detail.days" type="text" :disabled="true" />
                    </div>

                    <div class="col-12 mt-2">
                      <div class="d-flex align-items-center mb-1">
                        <label class="form-label ms-0 mb-0 me-3">
                          {{ $t("content.note") }}
                        </label>
                      </div>
                      <Textarea rows="3" v-model="postpone_detail.remark" class="w-100" />

                    </div>
                  </div>
                </fieldset>
              </div>

              <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
                  {{ cancel }}
                </button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="addPostpone" :disabled="postpone_detail.oldduedate >= postpone_detail.postponeDate || postpone_detail.days === '0'
                  || postpone_detail.remark.trim() === ''">
                  {{ save }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Remove UOV Dialog -->
        <div id="removeUOVModal" class="modal fade" tabindex="-1" aria-labelledby="removeUOVModalLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t("content.amnunitovermove") }}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>

              <div class="modal-body">
                <div class="row">
                  <p>{{ t("content.bodyunitovermove") }}</p>
                </div>
              </div>

              <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
                  {{ cancel }}
                </button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal">
                  {{ confirm }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Unseize Dialog -->
        <div id="unseizeModal" class="modal fade" tabindex="-1" aria-labelledby="unseizeModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t("content.unseize") }}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>

              <div class="modal-body">
                <fieldset>
                  <div class="row">
                    <div class="col-lg-4">
                      <div class="d-flex align-items-center mb-1">
                        <label class="form-label ms-0 mb-0 me-3">
                          {{ $t("content.amndantinfo") }}
                        </label>
                      </div>
                      <material-input id="informdate" :value="alertData.informdate" type="date" :disabled="true" />
                    </div>

                    <div class="col-lg-8">
                      <div class="d-flex align-items-center mb-1">
                        <label class="form-label ms-0 mb-0 me-3">
                          {{ $t("content.file") }}
                        </label>
                      </div>
                      <material-input id="attachments" :value="alertData.file" type="file" multiple />
                    </div>

                    <div class="col-12 mt-2">
                      <div class="d-flex align-items-center mb-1">
                        <label class="form-label ms-0 mb-0 me-3">
                          {{ $t("content.note") }}
                        </label>
                      </div>
                      <material-textarea id="informnote" :value="informnote" class="w-100" type="text" rows="3"
                        multi-line="true" />
                    </div>
                  </div>
                </fieldset>
              </div>

              <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
                  {{ cancel }}
                </button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal">
                  {{ save }}
                </button>
              </div>
            </div>
          </div>
        </div>

          <!-- Detail Modal -->
          <TicketDetailModal 
          v-if="workcaseDetail !== null"
          :workcaseDetail="workcaseDetail"
          :images="images"
          :listinfo="listinfo"
          :paymentE="paymentE"
          :paymentL="payment_l"
          :promotionDetail="promotionDetail"
          :depRef="dep_ref"
          :tkStatus="tk_status"
          :intCal="int_cal"
          :intPeriod="int_period"
          :transactionLabel="checkTransaction(workcaseDetail.transactionType)"
          :history="'no'" 
          v-model:fcusdt="fcusdt" 
          :afChangename=af_changename
          :bfChangename=bf_changename
          :transDatePrv=transdate_prv
          @copy="copyBtn"
          @openHistory="NewTab"/>


        <!--Customer Detail Modal -->
        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="exampleModalLabel">
                  {{ $t('content.bcustomer') }} :
                  <span style="color: blue;" v-if="cusShop.type !== 'rl'">
                    {{ cusShop.cusName }}
                  </span>
                  <span style="color: green;" v-else>
                    {{ cusShop.cusName }}
                  </span>
                </h1>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>
              <div class="modal-body">
                <div class="row mt-2">
                  <div class="col-lg-4">
                    <label class="form-label ms-0">{{ $t('content.cmobile') }}1*</label>
                    <InputMask v-model="cusShop.phoneNo1" mask="(999) 999-9999" fluid disabled />
                  </div>
                  <div class="col-lg-4">
                    <label class="form-label ms-0">{{ $t('content.cmobile') }}2</label>
                    <InputMask v-model="cusShop.phoneNo2" mask="(999) 999-9999" fluid disabled />
                  </div>
                  <div class="col-lg-4">
                    <label class="form-label ms-0">{{ $t('content.cmobile') }}3</label>
                    <InputMask v-model="cusShop.phoneNo3" mask="(999) 999-9999" fluid disabled />
                  </div>
                  <pre></pre>
                  <div class="col-4">
                    <label class="form-label ms-0">{{ $t('content.amntypecustomer') }}</label>
                    <select class="form-select" v-model="cusShop.cusTypeUid" disabled>
                      <option value="0" disabled selected>{{ $t('content.select') }}</option>
                      <option v-for="(item, index) in custypeList" :value="item.uid" :key="index">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-4">
                    <div class="flex-auto">
                      <label class="form-label ms-0">{{ $t('content.amncredit') }}</label>
                      <InputNumber v-model="cusShop.creditAmount" autocomplete="off" disabled fluid />
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { reactive, computed, ref, inject, onMounted, nextTick } from "vue";
import { useI18n } from "vue-i18n";
import ProgressSpinner from 'primevue/progressspinner';
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import MaterialTextarea from "@/components/MaterialTextarea.vue";
import Textarea from 'primevue/textarea';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import ExampleFive from "@/examples/ExampleOne";
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';
import InputMask from 'primevue/inputmask';
import InputNumber from 'primevue/inputnumber';
import TicketDetailModal from '@/components/TicketDetailModal.vue';

import moment from 'moment'
import noImg from "@/assets/img/noimg.png"
import axios from "axios";
import * as st from "@/config/setting.js";


import { useCategoryStore } from '@/stores/category'
import { usePostponeStore } from '@/stores/postpone'
import { useCustomerStore } from '@/stores/customer'
import { useBreakingStore } from '@/stores/breaking'
import { useJ6Store } from '@/stores/j6'
import { useCashAccountStore } from '@/stores/cashaccount'
import { useWorkCaseStore } from '@/stores/workcase'
import { useInterestStore } from '@/stores/interest'
import { usePaymentGroupStore } from '@/stores/paymentgroup'
import { useShopCatOrderStore } from '@/stores/shopcatorder'
import { useLotStore } from '@/stores/lot'
import { useShopStore } from '@/stores/shop'
import { useCusTypeStore } from '@/stores/custype'
import { useCusShopStore } from '@/stores/cusshop'
import { useDepositStore } from '@/stores/deposit'

const storec = useCategoryStore()
const storecus = useCustomerStore()
const storep = usePostponeStore()
const storebk = useBreakingStore()
const storej = useJ6Store()
const storeca = useCashAccountStore()
const storei = useInterestStore()
const storewc = useWorkCaseStore()
const storepm = usePaymentGroupStore()
const storeco = useShopCatOrderStore()
const storelo = useLotStore()
const storesh = useShopStore()
const storect = useCusTypeStore()
const storecuss = useCusShopStore()
const storedepo = useDepositStore()

const { t } = useI18n();
const swal = inject("$swal");

const currentYear = new Date().getFullYear();
const years = computed(() =>
  Array.from({ length: 5 }, (_, i) => currentYear - 4 + i)
    .slice()
    .reverse()
);

// const months = computed(() => Array.from({ length: 12 }, (_, i) => i));


const list_odstatus = ref([
  { items: computed(() => t("content.optall")), value: '' },
  { items: computed(() => t("content.amnunitover")), value: 'BREAKING' },
  { items: computed(() => t("content.amnstateacting")), value: 'ACTIVE' },
  { items: computed(() => t("content.scanin")), value: 'SCAN_IN' },
  { items: computed(() => t("content.scanout")), value: 'SCAN_OUT' },
  { items: computed(() => t("content.evalcom")), value: 'ESTIMATION_COMPLETE' },
  { items: computed(() => t("content.status_finish")), value: 'COMPLETE' },
])

const list_months = ref([
  { items: computed(() => t("opts.mon1")), value: 1 },
  { items: computed(() => t("opts.mon2")), value: 2 },
  { items: computed(() => t("opts.mon3")), value: 3 },
  { items: computed(() => t("opts.mon4")), value: 4 },
  { items: computed(() => t("opts.mon5")), value: 5 },
  { items: computed(() => t("opts.mon6")), value: 6 },
  { items: computed(() => t("opts.mon7")), value: 7 },
  { items: computed(() => t("opts.mon8")), value: 8 },
  { items: computed(() => t("opts.mon9")), value: 9 },
  { items: computed(() => t("opts.mon10")), value: 10 },
  { items: computed(() => t("opts.mon11")), value: 11 },
  { items: computed(() => t("opts.mon12")), value: 12 },
])

const alertData = reactive({
  oldduedate: "",
  newduedate: "",
  increaseday: "0",
  duenote: "",
});

///// computed
const cancel = computed(() => t("buttons.canc"));
const confirm = computed(() => t("buttons.conf"));
const save = computed(() => t("buttons.save"));
const btnSearch = computed(() => t("buttons.sear"));
const btnImport = computed(() => t("buttons.import"));
const btnExport = computed(() => t("buttons.export"));

const shop_detail = ref(null)
const shop_info = ref(null)
const status_search = ref('');

const year_search = ref('');
const month_search = ref('');

const cusUid_searchj = ref('');
const cusName_searchj = ref('');
const period_searchj = ref('');
const cat_searchj = ref('');
const tk_searchj = ref('');
const totalj6 = ref(0);
const selectedj6 = ref(0);

const cusUid_searchod = ref('');
const cusName_searchod = ref('');
const cat_searchod = ref('');
const tk_searchod = ref('');
const postpone_od = ref('');


const currentPageB = ref(1);
const totalRowsB = ref(1);
const perPageB = ref(10);
const totalRows_sB = ref();

const currentPageC = ref(1);
const totalRowsC = ref(1);
const perPageC = ref(10);
const totalRows_sC = ref();

const nameThC = ref('')
const nameEnC = ref('')
const docNumberC = ref('')
const customerlist = ref([])

const listprint = ref([]);
const listperiod = ref([]);
const listbk = ref([]);
const listj6 = ref([]);
const listod = ref([]);
const list_selected = ref([]);
const list_uid = ref([]);

const info_cat = ref('');
const workcaseDetail = ref(null);
const tk_status = ref('');
const int_cal = ref(0);
const paymentE = ref('');
const listinfo = ref([]);
const payment_l = ref([])
const loading = ref(false);
const subval = ref('1');
const listcat_order = ref([]);
const int_period = ref('');
const allj = ref(false);
const allod = ref(false);
const allse = ref(false);
const dep_ref = ref('');
const bf_changename = ref('');
const af_changename = ref('');

const images = ref([])
const images_l = ref([])

const canimportj6 = ref(false);
const canimportod = ref(false);
const canexport = ref(false);
const cansave = ref(false);
const promotionDetail = ref(null);
const fcusdt = ref(false)
const transdate_prv = ref(null);

const postpone_detail = ref({
  uid: '',
  workCaseUid: '', // always required
  postponeDate: '',
  days: '',
  remark: '',
  version: '',
  oldduedate: '',
  increaseday: '0',
  postponeCount: '0',
  type: '',
})

const custypeList = ref([])
const workcaseDetail_cus = ref(null);
const cusShop = ref({
  uid: '',
  cusUid: "",
  shopUid: "",
  cusTypeUid: "0",
  interestUid: "no",
  openAccountDate: null,
  lastActiveDate: null,
  phoneNo1: "",
  phoneNo2: "",
  phoneNo3: "",
  signature1Uid: "0",
  signature2Uid: "0",
  fingerPrint1Uid: "0",
  fingerPrint2Uid: "0",
  fgTemplate1Uid: "0",
  fgTemplate2Uid: "0",
  email: "",
  warningMsg: "",
  notifyWarning: false,
  creditAmount: 0,
  version: '0',
  cusName: "",
  type: ''
})


const format = (date) => {
  return moment(String(date)).local().format('DD/MM/YYYY');
}

function format_datetime(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY HH:mm:ss')
  }
}

function format_date(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY')
  }
}

const textInputOptions = {
  format: 'dd/MM/yyyy'
};


function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function copyBtn() {
  navigator.clipboard.writeText(workcaseDetail.value.tkRefNumber);
}

const NewTab = async () => {
  sessionStorage.removeItem('deferWorkcaseUid');
  sessionStorage.setItem("deferWorkcaseUid", workcaseDetail.value.uid);
  if (sessionStorage.getItem('deferWorkcaseUid') !== null) {
    const win = window.open("#/generals/defer_items", "_blank");
    win.focus();
    sessionStorage.removeItem('deferWorkcaseUid');
  }
}


const onClickHandlerBk = () => {
  updatePaginationBk()
};

const onClickHandlerC = () => {
  updatePaginationC()
};


const InfoFromSession = async (val) => {
  shop_detail.value = null
  const response = await storeca.cashaccountInfoFromSessionFetch();
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        shop_detail.value = response.data.data
        loadDataPrintApi()
        loadCusTypeListApi()
        // await loadBreakingListApi()
        // console.log('shop_detail : ' + JSON.stringify(shop_detail.value))
      }
    }
  }
}

InfoFromSession()

const loadDataPrintApi = async () => {
  let data = "";
  data = {
    uid: "",
  };
  const payload = data;
  const response = await storec.categorylistPrintFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listprint.value = response.data.data;
        if (listcat_order.value.length === 0) {
          await loadDataOrderCatApi()
        }
      }
    }
  }
};




const loadPriodApi = async () => {
  period_searchj.value = ''
  listperiod.value = []
  if (year_search.value !== '' && month_search.value !== '') {
    let data = "";
    data = {
      shopUid: shop_detail.value.uid,
      year: year_search.value,
      month: Number(month_search.value) - 1
    };
    const payload = data;
    const response = await storej.j6ListFetch(payload);
    if (response) {
      if (response.status === 200) {
        if (response.data.rtnDesc === "success") {
          listperiod.value = response.data.data.list;
        }
      }
    }
  }

};



const loadCusTypeListApi = async (val) => {
  let data = "";
  data = {
    index: 0,
    size: 100,
    name: "",
    shopUid: shop_detail.value.uid
  };
  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storect.custypeListFetch(payload);
  // console.log("loadCashAccDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        custypeList.value = response.data.data.list;
      }
    }
  }
}


async function loadBreakingListApi() {
  let data = "";
  data = {
    index: currentPageB.value - 1,
    size: perPageB.value,
    shopUid: shop_detail.value.uid,
    groupUid: shop_detail.value.groupUid,
    status: status_search.value,
    lotNumber: ""
  };
  const payload = data;
  const response = await storelo.lotListFetch(payload);
  // console.log("bl : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listbk.value = response.data.data.list
        totalRowsB.value = response.data.data.ext.total
        totalRows_sB.value = formatNumberString(totalRowsB.value)
      }
    }
  }
};

async function loadData() {
  allse.value = false
  if (period_searchj.value !== '') {
    await loadJ6ListApi()
  }
  await loadOverdueListApi()
}



async function loadJ6ListApi() {
  canimportj6.value = false
  allj.value = false
  totalj6.value = 0
  selectedj6.value = 0
  listj6.value = []
  let data = "";
  data = {
    cusUid: cusUid_searchj.value,
    refNumber: tk_searchj.value,
    j6Uid: period_searchj.value,
    priCatUid: cat_searchj.value,
  };
  const payload = data;
  // console.log("j6 p : " + JSON.stringify(payload));
  const response = await storebk.j6ListFetch(payload);
  // console.log("j6 r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list;
        totalj6.value = response.data.data.ext.allTotal
        listd.map(function (x) {
          x.chk = false;
          return x
        });
        listj6.value = listd
      }
    }
  }
};


async function loadOverdueListApi() {
  canimportod.value = false
  allod.value = false
  listod.value = []
  let data = "";
  let pr = '';
  pr = shop_detail.value.duePeroid.replace('m', '')
  let pp = false;
  if (postpone_od.value !== '') {
    pp = true
  }

  data = {
    cusUid: cusUid_searchod.value,
    refNumber: tk_searchod.value,
    period: Number(pr),
    priCatUid: cat_searchod.value,
    postpone: pp
  };
  const payload = data;
  // console.log("od p : " + JSON.stringify(payload));
  const response = await storebk.OverdueListFetch(payload);
  // console.log("od r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list;
        listd.map(function (x) {
          x.chk = false;
          return x
        });
        listod.value = listd
      }
    }
  }
};


async function updatePaginationBk() {
  listbk.value = []
  let data = "";
  data = {
    index: currentPageB.value - 1,
    size: perPageB.value,
    shopUid: shop_detail.value.uid,
    groupUid: shop_detail.value.groupUid,
    status: status_search.value,
    lotNumber: ""
  };
  const payload = data;
  const response = await storelo.lotListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listbk.value = response.data.data.list
        totalRowsB.value = response.data.data.ext.total
        totalRows_sB.value = formatNumberString(totalRowsB.value)
      }
    }
  }
}

function filterStatus(str) {
  let side = ''
  let name = list_odstatus.value.filter((c) => c.value === str);
  if (name.length > 0) {
    side = name[0].items
  }
  return side
}

function filterCat(str) {
  let side = ''
  let name = listprint.value.filter((c) => c.uid === str);
  if (name.length > 0) {
    side = name[0].name
  }
  return side
}


function cancelBtnJ6() {
  cusUid_searchj.value = '';
  cusName_searchj.value = '';
  tk_searchj.value = '';
  year_search.value = '';
  month_search.value = '';
  period_searchj.value = '';
  cat_searchj.value = '';
  tk_searchj.value = '';
  listj6.value = []
  listperiod.value = []
}



function cancelBtnOd() {
  cusUid_searchod.value = '';
  cusName_searchod.value = '';
  tk_searchod.value = '';
  cat_searchod.value = '';
  postpone_od.value = '';
  listod.value = []
  onClickSubTab('2')
}


async function onClickTab(val) {
  if (val === '1') {
    if (listbk.value.length === 0) {
      currentPageB.value = 1
      status_search.value = ''
      await loadBreakingListApi()
    }
    // await setfirstTab()
  } else if (val === '2') {
    await setsecondTab()
    await onClickSubTab('1')
  }
}

async function onClickSubTab(val) {
  if (val === '1') {
    subval.value = '1'
    if (period_searchj.value !== '' && listj6.value.length === 0) {
      await loadJ6ListApi()
    }
    await setsubfirstTab()
  } else if (val === '2') {
    subval.value = '2'
    if (listod.value.length === 0) {
      await loadOverdueListApi()
    }
    await setsubsecondTab()
  }
}

// async function setfirstTab() {
//   if (document.getElementById("second-unitover")) {
//     document.getElementById("second-unitover").classList.remove('show', 'active')
//   }

//   if (document.getElementById("secondUnitover")) {
//     document.getElementById("secondUnitover").classList.remove('show', 'active')
//   }

//   if (document.getElementById("first-unitover")) {
//     document.getElementById("first-unitover").classList.add('show', 'active')
//   }

//   if (document.getElementById("firstUnitover")) {
//     document.getElementById("firstUnitover").classList.add('show', 'active')
//   }
// }

async function setsecondTab() {
  if (document.getElementById("first-unitover")) {
    document.getElementById("first-unitover").classList.remove('show', 'active')
  }

  if (document.getElementById("firstUnitover")) {
    document.getElementById("firstUnitover").classList.remove('show', 'active')
  }

  if (document.getElementById("second-unitover")) {
    document.getElementById("second-unitover").classList.add('show', 'active')
  }

  if (document.getElementById("secondUnitover")) {
    document.getElementById("secondUnitover").classList.add('show', 'active')
  }

}


async function setsubfirstTab() {
  if (document.getElementById("second-unitoverman")) {
    document.getElementById("second-unitoverman").classList.remove('show', 'active')
  }

  if (document.getElementById("secondUnitoverMan")) {
    document.getElementById("secondUnitoverMan").classList.remove('show', 'active')
  }

  if (document.getElementById("first-unitoverman")) {
    document.getElementById("first-unitoverman").classList.add('show', 'active')
  }

  if (document.getElementById("firstUnitoverMan")) {
    document.getElementById("firstUnitoverMan").classList.add('show', 'active')
  }
}

async function setsubsecondTab() {
  if (document.getElementById("first-unitoverman")) {
    document.getElementById("first-unitoverman").classList.remove('show', 'active')
  }

  if (document.getElementById("firstUnitoverMan")) {
    document.getElementById("firstUnitoverMan").classList.remove('show', 'active')
  }

  if (document.getElementById("second-unitoverman")) {
    document.getElementById("second-unitoverman").classList.add('show', 'active')
  }

  if (document.getElementById("secondUnitoverMan")) {
    document.getElementById("secondUnitoverMan").classList.add('show', 'active')
  }

}

async function openDialogCus() {
  nameThC.value = ''
  nameEnC.value = ''
  docNumberC.value = ''
  customerlist.value = []
  if (subval.value === '1') {
    cusUid_searchj.value = ''
    cusName_searchj.value = ''
  } else if (subval.value === '2') {
    cusUid_searchod.value = ''
    cusName_searchod.value = ''
  }

  document.getElementById("searchNameCus").click();

}


async function selectCus(item) {
  if (subval.value === '1') {
    cusUid_searchj.value = item.uid
    cusName_searchj.value = item.nameTh
  } else if (subval.value === '2') {
    cusUid_searchod.value = item.uid
    cusName_searchod.value = item.nameTh
  }
  document.getElementById("closeModal").click();
}


async function loadCustomerAfListApi() {
  currentPageC.value = 1
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value

  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storecus.searchCustomerFetch(payload);
  // console.log("loadCustomerListApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list;
        customerlist.value = listd;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}

async function updatePaginationC() {
  customerlist.value = []
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value

  };
  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storecus.searchCustomerFetch(payload);
  // console.log("loadCashAccDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        customerlist.value = response.data.data.list;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}


async function loadDataOrderCatApi() {
  listcat_order.value = []
  let data = "";
  let list = []
  data = {
    index: 0,
    size: '100',
    shopUid: shop_detail.value.uid
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storeco.shopCatOrderListFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        list = response.data.data.list;
        if (list.length !== 0) {
          listcat_order.value = list[0].catOrders
          listcat_order.value = Object.values(listcat_order.value)
          // console.log("listcat_order : " + JSON.stringify(listcat_order.value));
        }
      }
    }
  }
}


const diffDate = () => {
  var start = moment(new Date(postpone_detail.value.oldduedate)).format('YYYY-MM-DD');
  var end = moment(new Date(postpone_detail.value.postponeDate));
  var diff = end.diff(start, "days")
  postpone_detail.value.days = String(Number(diff + 1))
  return;
};


async function showModal(item) {
  clearItem();
  workcaseDetail.value = null
  await getworkCaseInfo(item.uid)
  if (workcaseDetail.value !== null) {
    postpone_detail.value.workCaseUid = item.uid
    postpone_detail.value.postponeCount = workcaseDetail.value.postponeCount
    postpone_detail.value.days = '0'
    if (workcaseDetail.value.postponeCount > 0) {
      postpone_detail.value.postponeDate = new Date(workcaseDetail.value.postponeDate)
      postpone_detail.value.oldduedate = new Date(workcaseDetail.value.postponeDate)
    } else {
      postpone_detail.value.postponeDate = new Date(workcaseDetail.value.dueDate)
      postpone_detail.value.oldduedate = new Date(workcaseDetail.value.dueDate)
    }
    document.getElementById("addpostpone").click();

  }

}

function clearItem() {
  postpone_detail.value = {
    uid: '',
    workCaseUid: '', // always required
    postponeDate: '',
    days: '',
    remark: '',
    version: '',
    oldduedate: '',
    increaseday: '0',
    postponeCount: '0',
    type: '',
  }
}

async function addPostpone() {
  const payload = postpone_detail.value;
  payload.type = 'USER'
  payload.postponeDate = moment(new Date(payload.postponeDate)).format('YYYY-MM-DDT00:00:00')
  // console.log('app p : ' + JSON.stringify(payload));
  const response = await storep.postPoneAddFetch(payload);
  // console.log('app r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        await loadOverdueListApi()
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }

}


async function setAllJ6() {
  if (allj.value) {
    canimportj6.value = true
    for (let i = 0; i < listj6.value.length; i++) {
      if (listj6.value[i].catName !== null && listj6.value[i].catName !== undefined && listj6.value[i].catName !== '') {
         listj6.value[i].chk = true
      }
    }
  } else {
    canimportj6.value = false
    for (let i = 0; i < listj6.value.length; i++) {
      listj6.value[i].chk = false
    }
  }
}

async function selectJ6(item) {
  if (allj.value) {
    if (item.chk === false) {
      allj.value = false
    }
  }
  canimportj6.value = false
  for (let i = 0; i < listj6.value.length; i++) {
    if (listj6.value[i].chk) {
      canimportj6.value = true
      break
    }
  }
}


async function setAllOd() {
  if (allod.value) {
    canimportod.value = true
    for (let i = 0; i < listod.value.length; i++) {
      if (listod.value[i].catName !== null && listod.value[i].catName !== undefined && listod.value[i].catName !== '') {
        listod.value[i].chk = true
      }  
    }
  } else {
    canimportod.value = false
    for (let i = 0; i < listod.value.length; i++) {
      listod.value[i].chk = false
    }
  }
}

async function selectOd(item) {
  if (allod.value) {
    if (item.chk === false) {
      allod.value = false
    }
  }
  canimportod.value = false
  for (let i = 0; i < listod.value.length; i++) {
    if (listod.value[i].chk) {
      canimportod.value = true
      break
    }
  }
}


async function setAllSe() {
  if (allse.value) {
    canexport.value = true
    cansave.value = true
    selectedj6.value = 0
    for (let i = 0; i < list_selected.value.length; i++) {
      list_selected.value[i].chk = true
      if (list_selected.value[i].type === 'j6') {
        selectedj6.value = selectedj6.value + 1
      }
    }
  } else {
    canexport.value = false
    cansave.value = false
    selectedj6.value = 0
    for (let i = 0; i < list_selected.value.length; i++) {
      list_selected.value[i].chk = false
    }
  }
}


async function selectSe(item) {
  if (allse.value) {
    if (item.chk === false) {
      allse.value = false
    }
  }

  canexport.value = false
  cansave.value = false
  selectedj6.value = 0
  for (let i = 0; i < list_selected.value.length; i++) {
    if (list_selected.value[i].chk) {
      if (list_selected.value[i].type === 'j6') {
        selectedj6.value = selectedj6.value + 1
      }
      canexport.value = true
      cansave.value = true
    }
  }

}

async function setList() {

  for (let i = 0; i < listj6.value.length; i++) {
    if (listj6.value[i].chk) {
      let lp = list_uid.value.filter((c) => c === listj6.value[i].uid);
      if (lp.length === 0) {
        list_selected.value.push({ uid: listj6.value[i].uid, refNumber: listj6.value[i].refNumber, cusName: listj6.value[i].cusName, pawnDate: listj6.value[i].pawnDate, catName: listj6.value[i].catName, weight: listj6.value[i].weight, quantity: listj6.value[i].quantity, pawnValue: listj6.value[i].pawnValue, chk: false, type: 'j6' })
        list_uid.value.push(listj6.value[i].uid)
      }
    }
  }

  for (let i = 0; i < listod.value.length; i++) {
    if (listod.value[i].chk) {
      let lp = list_uid.value.filter((c) => c === listod.value[i].uid);
      if (lp.length === 0) {
        list_selected.value.push({ uid: listod.value[i].uid, refNumber: listod.value[i].refNumber, cusName: listod.value[i].cusName, pawnDate: listod.value[i].pawnDate, catName: listod.value[i].catName, weight: listod.value[i].weight, quantity: listod.value[i].quantity, pawnValue: listod.value[i].pawnValue, chk: false, type: 'od' })
        list_uid.value.push(listod.value[i].uid)
      }
    }
  }


}

async function unsetList() {
  let list_unselected = list_selected.value
  let listunselect = []
  let listunuid = []
  for (let i = 0; i < list_unselected.length; i++) {
    //   console.log('un chk : ' + list_unselected[i].uid + ' , chk : ' + list_unselected[i].chk);
    if (list_unselected[i].chk) {
      if (list_unselected[i].type === 'j6') {
        let index = listj6.value.findIndex(x => x.uid === list_unselected[i].uid);
        listj6.value[index].chk = false
        allj.value = false
      } else if (list_unselected[i].type === 'od') {
        let index = listod.value.findIndex(x => x.uid === list_unselected[i].uid);
        listod.value[index].chk = false
        allod.value = false
      }

    } else {
      listunselect.push({ uid: list_unselected[i].uid, refNumber: list_unselected[i].refNumber, cusName: list_unselected[i].cusName, pawnDate: list_unselected[i].pawnDate, catName: list_unselected[i].catName, weight: list_unselected[i].weight, quantity: list_unselected[i].quantity, pawnValue: list_unselected[i].pawnValue, chk: list_unselected[i].chk, type: list_unselected[i].type })
      listunuid.push(list_unselected[i].uid)
    }
  }

  allse.value = false
  list_selected.value = listunselect
  list_uid.value = listunuid

  canexport.value = false
  cansave.value = false
  selectedj6.value = 0
  for (let i = 0; i < list_selected.value.length; i++) {
    if (list_selected.value[i].chk) {
      if (list_selected.value[i].type === 'j6') {
        selectedj6.value = selectedj6.value + 1
      }
      canexport.value = true
      cansave.value = true
    }
  }
}



async function addBreaking() {
  selectedj6.value = 0
  for (let i = 0; i < list_selected.value.length; i++) {
    if (list_selected.value[i].chk) {
      if (list_selected.value[i].type === 'j6') {
        selectedj6.value = selectedj6.value + 1
      }
    }
  }

  if (selectedj6.value !== 0 && selectedj6.value !== totalj6.value) {
    swal("บันทึกไม่สำเร็จ", "กรุณาเลือกรายการจ.6ทั้งหมด", "error");
  } else {
    let data = "";
    data = {
      list: list_uid.value
    };
    const payload = data;
    // console.log('addBreaking p : ' + JSON.stringify(payload));
    const response = await storelo.lotAddFetch(payload);
    // console.log('addBreaking r : ' + JSON.stringify(response.data));
    if (response) {
      if (response.status === 200) {
        if (response.data.rtnDesc === "success") {
          swal("บันทึกสำเร็จ", "", "success");
          list_selected.value = []
          list_uid.value = []
          canexport.value = false
          cansave.value = false
          loadData()
        } else {
          swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
        }
      }
    }
  }



}

async function openDetail(item) {
   workcaseDetail.value = null
  images.value = []
  images_l.value = []
  listinfo.value = []
  tk_status.value = ''
  int_cal.value = 0
  paymentE.value = ''
  int_period.value = ''
  fcusdt.value = false
  dep_ref.value = ''
  bf_changename.value = ''
  af_changename.value = ''
  transdate_prv.value = null
  promotionDetail.value = null

  await getworkCaseInfo(item.uid)
  if (workcaseDetail.value != null) {

    if (workcaseDetail.value.changeName ) {
      af_changename.value = item.cusName
      await getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
    }else { 
      if (workcaseDetail.value.transactionType !== 'PAWN') { 
          await getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
      }
    }

    if (workcaseDetail.value.deposit) {
      await getDepositInfo(workcaseDetail.value.tkRefNumber)
    }
    await detailPayment(workcaseDetail.value.paymentGroupUid)

    images_l.value = workcaseDetail.value.ticket.images
    listinfo.value = workcaseDetail.value.ticket.collaterals

    if (workcaseDetail.value.promotionUid !== '0') { 
          await retrieveInfo(workcaseDetail.value)
    }

    if (workcaseDetail.value.transactionType !== 'REDEEM') {
      if(workcaseDetail.value.latest){
        await calIntInt()
      }
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ปกติ'
      } else if (workcaseDetail.value.status === 'FREEZE') {
        tk_status.value = 'อายัด'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      } else if (workcaseDetail.value.status === 'ACTIVE') {
        tk_status.value = 'กำลังดำเนินการ'
      } else if (workcaseDetail.value.status === 'BREAKING') {
        tk_status.value = 'ของหลุด'
      }

    } else {
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ไถ่ถอน'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      }
    }
    if (images_l.value.length > 0) {
      getTicketImage()
    } else {
      let obj = {
        src: noImg,
        thumbnailImageSrc: noImg,
        alt: '',
        title: ''
      }
      images.value.push(obj)
      await nextTick();
      document.getElementById("detailModal").click();

    }
  }
}


async function getTicketImage() {
  if (images.value.length === 0) {
    let url = []
    images.value = []
    for (let i = 0; i < images_l.value.length; i++) {
      // console.log("logoUid : " + item.images[i].imageUid);
      if (images_l.value[i].imageUid !== "0") {
        url.push(String(st.url_api + "/doc-svc/document/info/" + images_l.value[i].imageUid));
      }
    }
    if (url.length > 0) {
      await getFile(url)
      // setTimeout(3000);
      if (images.value.length > 0) {
        await nextTick();
        document.getElementById("detailModal").click();
      } else {
        let obj = {
          src: noImg,
          thumbnailImageSrc: noImg,
          alt: '',
          title: ''
        }
        images.value.push(obj)
        await nextTick();
        document.getElementById("detailModal").click();
      }
    } else {
      let obj = {
        src: noImg,
        thumbnailImageSrc: noImg,
        alt: '',
        title: ''
      }
      images.value.push(obj)
      await nextTick();
      document.getElementById("detailModal").click();
    }
  } else {
    await nextTick();
    document.getElementById("detailModal").click();
  }
}


async function getFile(urls) {
  let file_L = []
  const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
  const accessToken = key.accessToken;
  axios.defaults.headers["Authorization"] = `Bearer ${accessToken}`;
  const requests = urls.map((url) => axios.get(url));
  await Promise.all(requests).then(allResults => {
    if (allResults) {
      file_L = allResults
      if (file_L !== null) {
        // console.log('file_L : ' + JSON.stringify(file_L))
        for (let i = 0; i < file_L.length; i++) {
          // console.log('file_L : ' + JSON.stringify(file_L.value[i].data.data.data) + ' file_L 2 : ' + JSON.stringify(file_L.value[i].data.data.name));
          if (file_L[i].data.data !== null) {
            const file = getFileFromBase64(file_L[i].data.data.data, file_L[i].data.data.name)
            const data = URL.createObjectURL(file);
            let obj = {
              src: data,
              thumbnailImageSrc: data,
              alt: '',
              title: ''
            }
            images.value.push(obj)
          }

          // console.log('File xx : ', file_L.value[i].file.type + 'File size : ', file_L.value[i].file.size + ' bytes in size  name : ' + file_L.value[i].data.data.name);
        }
      }
    }
  })

}

function getFileFromBase64(string64, fileName) {
  const trimmedString = string64.replace('dataimage/jpegbase64', '');
  // const trimmedString = string64;
  const imageContent = atob(trimmedString);
  const buffer = new ArrayBuffer(imageContent.length);
  const view = new Uint8Array(buffer);

  for (let n = 0; n < imageContent.length; n++) {
    view[n] = imageContent.charCodeAt(n);
  }
  var ext = fileName.split('.').pop();
  let type = '';
  if (ext === 'jpg') {
    type = 'image/jpeg'
  } else if (ext === 'png') {
    type = 'image/png'
  }
  const blob = new Blob([buffer], { type });
  return new File([blob], fileName, { lastModified: new Date().getTime(), type });
}

async function getworkCaseInfo(id) {
  let data = "";
  data = {
    uid: id,
  };
  const payload = data;

  const response = await storewc.workCaseinfoFetch(payload);
  // console.log("getworkCaseInfo : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseDetail.value = response.data.data
      }
    }
  }
}


async function calIntInt() {
  let postponeDate = ''
  if (workcaseDetail.value.postponeCount != 0) {
    postponeDate = moment(workcaseDetail.value.postponeDate).format('YYYY-MM-DD')
  }
  let data = "";
  let pawnValue = 0
  if (workcaseDetail.value.transactionType != 'REDEEM') {
    pawnValue = workcaseDetail.value.newPawnValue
  } else {
    pawnValue = workcaseDetail.value.pawnValue
  }
  let cusUid = workcaseDetail.value.customerInfo.customerUid
    
  if(workcaseDetail.value.represent || workcaseDetail.value.shopRepresent){
      cusUid =  workcaseDetail.value.tkCustomerInfo.customerUid 
  }
  
  data = {
    cusUid: cusUid,
    txType: workcaseDetail.value.transactionType,
    pawnDate: moment(workcaseDetail.value.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    postponeDate: postponeDate,
    pawnValue: pawnValue,
    promotionUid: workcaseDetail.value.promotionUid,
    interestUid: workcaseDetail.value.interestUid,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestCalculateFetch(payload);
  // console.log("calIntInt r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        int_cal.value = Number(res.overdueInterest) + Number(res.dueInterest)
        int_period.value = res.interestPeriod

      }
    }
  }
}

async function detailPayment(item) {
  // console.log('detailPayment : ' + item);
  let data = "";
  data = {
    uid: item,
  };
  const payload = data;
  const response = await storepm.paymentGroupinfoFetch(payload);

  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        paymentE.value = response.data.data
        filterPayType()
        // console.log('detailPayment : ' + JSON.stringify(paymentE.value));
      }
    }
  }
}

function checkTransaction(str) {
  // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
  let side = ''
  if (str === 'PAWN') {
    side = 'จำนำ'
  } else if (str === 'INTEREST') {
    side = 'ต่อดอกเบี้ย'
  } else if (str === 'REDEEM') {
    side = 'ไถ่ถอน'
  } else if (str === 'INC_PRINCIPLE') {
    side = 'เพิ่มต้น'
  } else if (str === 'DEC_PRINCIPLE') {
    side = 'ลดต้น'
  }
  return side
}

function filterPayType() {
  payment_l.value = []
  let pt = [{ name: 'CASH' },
  { name: 'BANK_TRANSFER' },
  { name: 'CREDIT_CARD' },
  { name: 'CHEQUE' },
  { name: 'PROMPT_PAY_MOBILE' },
  { name: 'PROMPT_PAY_TAX_ID' },
  { name: 'QR_CODE' },
  ]
  let lsum = []
  for (let i = 0; i < pt.length; i++) {
    lsum = filterSumPay(pt[i].name)
    if (lsum.length > 0) {
      payment_l.value.push({ name: pt[i].name, pay: lsum[0].pay, receive: lsum[0].receive, fee: lsum[0].fee })
    } else {
      payment_l.value.push({ name: pt[i].name, pay: 0, receive: 0, fee: 0 })
    }
  }
}

function filterSumPay(str) {
  let nump = 0, numr = 0, numf = 0
  let lp = paymentE.value.payments.filter((c) => c.type === str);
  if (lp.length > 0) {
    let pay = 0
    let receive = 0
    let fee = 0
    for (let i = 0; i < lp.length; i++) {
      pay = pay + lp[i].pay
      receive = receive + lp[i].receive
      fee = fee + lp[i].feeReceive
      // fee = fee + lp[i].fee
    }
    nump = pay
    numr = receive
    numf = fee
  }
  let lockL = []
  lockL.push({ pay: nump, receive: numr, fee: numf })
  // console.log('lockL : ' + JSON.stringify(lockL));
  return lockL
}


async function getShopInfo() {
  shop_info.value = null
  let data = "";
  data = {
    uid: shop_detail.value.uid,
  };
  const payload = data;
  const response = await storesh.shopInfoFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        shop_info.value = response.data.data
        // console.log('shop_info : ' + JSON.stringify(shop_info.value));
      }
    }
  }
}

async function XlsxGen(item) {
  loading.value = true
  await getShopInfo()
  let data = "";
  data = {
    groupUid: shop_info.value.groupUid,
    shopUid: shop_info.value.uid,
    lotUid: item.uid,
    shopInfo: shop_info.value.fullname,
  };
  const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
  const accessToken = keya.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/pawn-rpt-svc/breaking/lot/xlsx`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  if (response.headers.get("content-type") === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    // console.log('XlsxGen : ' + JSON.stringify(response.headers.get("content-type")));
    let today = moment(new Date()).local().format('YYYYMMDD_HHmmss')
    let fileName = item.lotNumber + `_${today}.xlsx`
    const url = URL.createObjectURL(new Blob([response.data], { type: "application/xlsx" }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
  } else {
    swal("โหลด EXCEL ไม่สำเร็จ", "", "error");
  }
}


async function getCustomerWorkcase(id) {
  workcaseDetail_cus.value = null
  let data = "";
  data = {
    uid: id,
  };
  const payload = data;

  const response = await storewc.workCaseinfoFetch(payload);
  // console.log("getworkCaseInfo : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseDetail_cus.value = response.data.data
        // console.log("workcaseDetail_cus : " + JSON.stringify(workcaseDetail_cus.value));
      }
    }
  }
}


async function searchCustomer(item) {
  // console.log('cusUid : ' + item.cusUid)
  await clearCustomer()
  await getCustomerWorkcase(item.uid)
  if (workcaseDetail_cus.value != null) {
    let data = "";
    data = {
      uid: workcaseDetail_cus.value.tkCustomerInfo.customerUid,
    };

    const payload = data;
    const response = await storecuss.cusShopInfoByCusUidFetch(payload);
    // console.log("CusshopInfo : " + JSON.stringify(response.data));
    if (response) {
      if (response.status === 200) {
        if (response.data.rtnDesc === "success") {
          if (response.data.data !== null) {
            cusShop.value = response.data.data
            cusShop.value.cusName = item.cusName
            cusShop.value.type = 'cus'
            document.getElementById("exampleModalShow").click();
          }
        }
      }
    }
  } else {
    swal("Record not found", "", "error");
  }
}


async function clearCustomer() {
  cusShop.value = {
    uid: '',
    cusUid: "",
    shopUid: "",
    cusTypeUid: "0",
    interestUid: "no",
    openAccountDate: null,
    lastActiveDate: null,
    phoneNo1: "",
    phoneNo2: "",
    phoneNo3: "",
    signature1Uid: "0",
    signature2Uid: "0",
    fingerPrint1Uid: "0",
    fingerPrint2Uid: "0",
    fgTemplate1Uid: "0",
    fgTemplate2Uid: "0",
    email: "",
    warningMsg: "",
    notifyWarning: false,
    creditAmount: 0,
    version: '',
    cusName: "",
    type: ''
  }
}


async function searchRlCustomer(item) {
  // console.log('cusUid : ' + item.cusUid)
  await clearCustomer()
  await getCustomerWorkcase(item.uid)
  if (workcaseDetail_cus.value != null) {
    let data = "";
    data = {
      uid: workcaseDetail_cus.value.rlCustomerInfo.customerUid,
    };

    const payload = data;
    const response = await storecuss.cusShopInfoByCusUidFetch(payload);
    // console.log("CusshopInfo : " + JSON.stringify(response.data));
    if (response) {
      if (response.status === 200) {
        if (response.data.rtnDesc === "success") {
          if (response.data.data !== null) {
            cusShop.value = response.data.data
            cusShop.value.cusName = item.relatedName
            cusShop.value.type = 'rl'
            document.getElementById("exampleModalShow").click();
          }
        }
      }
    }
  } else {
    swal("Record not found", "", "error");
  }
}

async function getDepositInfo(tkRef) {
  let data = "";
  data = {
    index: 0,
    size: 1,
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    cusUid: '',
    refNumber: '',
    tkRefNumber: tkRef.trim(),
    channel: '',
    txDate: 0,
  };
  const payload = data;
  // console.log("ld p : " + JSON.stringify(payload));
  const response = await storedepo.listDepositFetch(payload);
  // console.log("ld r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list
        dep_ref.value = listd[0].refNumber
      }
    }
  }
}


async function getworkCaseInfoPrv(prevRefNumber) {
  let workcase_prv = null
  let data = "";
  data = {
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    refNumber: prevRefNumber,
  };
  const payload = data;

  const response = await storewc.workCaseInfoByRefFetch(payload);
  //  console.log("workCaseInfoByRef : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcase_prv = response.data.data
        bf_changename.value = workcase_prv.tkCustomerInfo.name
        transdate_prv.value = workcase_prv.workItems[0].startTime 
      }
    }
  }
}

async function retrieveInfo(item) {
  promotionDetail.value = null
  let data = "";
  let pawnValue = 0
  if (item.transactionType != 'REDEEM') {
      pawnValue = item.newPawnValue
  } else {
      pawnValue = item.pawnValue
  }

  let cusUid = item.customerInfo.customerUid

  if(item.represent || item.shopRepresent){
     cusUid =  item.tkCustomerInfo.customerUid 
  }

  data = {
    cusUid : cusUid,
    pawnDate: moment(item.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    pawnValue: pawnValue,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestRetrieveFetch(payload);
  // console.log("retrieveInfo r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        const result = res.interests.flatMap(item => {
        // เงื่อนไข: เป็นโปรโมชัน และ periodMonths > 1
        if (item.promotion === true && item.periodMonths > 1) {
          // สร้าง Array ใหม่ที่มีจำนวน element เท่ากับ periodMonths และใส่ข้อมูล item ลงไป
          return Array.from({ length: item.periodMonths }, () => ({ ...item }));
        }
        // หากไม่ตรงเงื่อนไข ให้คืนค่าเดิมกลับไป 1 ชุด
        return [item];
        });
        // console.log('result : ' + JSON.stringify(result));
      res.interests  =  result
      promotionDetail.value = res
      // console.log('promotionDetail : ' + JSON.stringify(promotionDetail.value));
      }
    }
  }
}


onMounted(() => {
  if (document.getElementById("second-unitover")) {
    document.getElementById("second-unitover").classList.add('show', 'active')
  }

  if (document.getElementById("secondUnitover")) {
    document.getElementById("secondUnitover").classList.add('show', 'active')
  }
  if (document.getElementById("first-unitoverman")) {
    document.getElementById("first-unitoverman").classList.add('show', 'active')
  }

  if (document.getElementById("firstUnitoverMan")) {
    document.getElementById("firstUnitoverMan").classList.add('show', 'active')
  }
});


</script>

<style lang="scss" scoped>
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
